import { useFetchPage } from "~/core/composables/useFetchPage";
import type { SearchMode } from "~/core/composables/useSearch";
import { useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import filtersUtils from "~/core/utils/filters.utils";
import type { KeystoreCertificate } from "~/modules/certificate/models/KeystoreCertificate.interface";
import keystoreService from "~/modules/certificate/services/keystore.service";
import type { FiltersSelection } from "~/types";
import {
  Filters,
  FiltersType,
  OPERATOR_RSQL_IN,
  OPERATOR_RSQL_LIKE,
} from "~/types";

export function useKeystore(
  searchMode?: SearchMode,
  useQueryParametersForPagination?: boolean,
): UseFetchResponse<KeystoreCertificate> {
  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.KEYSTORE_ALIAS,
      {
        key: "alias",
        operator: OPERATOR_RSQL_LIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
    [
      Filters.KEYSTORE_TAGS,
      { key: "tags", operator: OPERATOR_RSQL_IN, value: [] },
    ],
  ]);

  const service = keystoreService.getListOfCertificates.bind(keystoreService);
  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );
  const { sort, onSortChange } = useSort();
  const { isLoading, results, error, fetchData } = useFetchPage({
    service,
    searchParams,
    sort,
    useQueryParametersForPagination,
  });

  return {
    error,
    fetchData,
    filters,
    isLoading,
    onSearch,
    onSortChange,
    results,
    search,
    setFilter,
  };
}
